import React from "react";
import { useSnapshot } from "valtio";
import { voiceAgentStore } from "../../../../../store/voiceAgentStore";

const Header: React.FC = () => {
  const { speaker, status, isMuted, hasMicPermission } =
    useSnapshot(voiceAgentStore);

  const getSubtitle = () => {
    // Show error states first
    if (status === "error") {
      if (hasMicPermission === false) {
        return "🚫 Microphone permission denied. Please allow access to continue.";
      }
      return "❌ Connection error. Please try again.";
    }

    if (status === "connecting") {
      return "Requesting microphone access...";
    }

    if (status === "idle" || status === "stopped") {
      return "Ready to start";
    }

    if (isMuted) {
      return "You are muted";
    }

    switch (speaker) {
      case "user":
        return "You are speaking...";
      case "ai":
        return "FiBi is speaking...";
      default:
        return "Listening...";
    }
  };

  const getTextColor = () => {
    if (status === "error") return "text-red-600";
    if (isMuted) return "text-red-500";
    return "text-gray-600";
  };

  return (
    <div className="text-center">
      <h1 className="text-5xl font-bold text-gray-800 mb-2">FiBi</h1>
      <p className={`${getTextColor()} transition-colors duration-300`}>
        {getSubtitle()}
      </p>
    </div>
  );
};

export default Header;
